import { render, staticRenderFns } from "./InsuranceStepForm.vue?vue&type=template&id=25e866a5"
import script from "./InsuranceStepForm.vue?vue&type=script&lang=js"
export * from "./InsuranceStepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports